module.exports = "<div class=\"ngx-editor-message\" *ngIf=\"ngxMessage\" (dblclick)=\"clearMessage()\">\r\n  {{ ngxMessage }}\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/externals/ngx-editor/src/ngx-editor-message/ngx-editor-message.component.html
// module id = ./src/externals/ngx-editor/src/ngx-editor-message/ngx-editor-message.component.html
// module chunks = main